// frontend/src/pages/Admin/Settings.jsx
import { useState, useEffect } from 'react';
import { getAdminSettings } from '../../api/services';

export default function AdminSettings() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const { data } = await getAdminSettings();
            setSettings(data);
        } catch (error) {
            console.error('Failed to fetch settings:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <svg className="animate-spin h-10 w-10 text-brand-amber" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
                    <path className="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
            </div>
        );
    }

    if (!settings) return null;

    const rows = [
        { label: 'Rate Limit Requests', desc: 'Maximum requests per window', value: settings.rate_limit_requests },
        { label: 'Rate Limit Window', desc: 'Time window in seconds', value: `${settings.rate_limit_window}s` },
        { label: 'Freemium Limit', desc: 'Free analyses per session', value: settings.freemium_limit },
        { label: 'JWT Expiry', desc: 'Token expiration in hours', value: `${settings.jwt_expiry_hours}h` },
    ];

    return (
        <div>
            <h1 className="font-display text-2xl font-bold text-brand-text mb-6">System Settings</h1>

            <div className="card">
                <div className="space-y-1">
                    {rows.map((row) => (
                        <div key={row.label} className="flex justify-between items-center border-b border-brand-border py-4 last:border-0">
                            <div>
                                <p className="font-medium text-brand-text font-body">{row.label}</p>
                                <p className="text-sm text-brand-muted font-body">{row.desc}</p>
                            </div>
                            <span className="px-3 py-1 bg-brand-amber/10 text-brand-amber rounded-full font-body text-sm">{row.value}</span>
                        </div>
                    ))}

                    <div className="flex justify-between items-center py-4">
                        <div>
                            <p className="font-medium text-brand-text font-body">Environment</p>
                            <p className="text-sm text-brand-muted font-body">Current runtime environment</p>
                        </div>
                        <span className={`px-3 py-1 rounded-full font-body text-sm ${settings.environment === 'production' ? 'bg-green-500/10 text-green-400' : 'bg-orange-500/10 text-orange-400'
                            }`}>
                            {settings.environment}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}